import React from 'react';
// Constants
import { CompanyName, KeywordsPages } from '../../utils/Constants';
// Data
import {
  linksPageAdditionalMeta,
  linksPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import LinksPageMainContainer from '../../components/links/LinksPageMainContainer';
import FooterComponent from '../../components/footer/FooterComponent';

function LinksPage() {
  return (
    <>
      <HelmetItem
        PageName='External Links & Pay Sites'
        desc={`Explore the exclusive world of ${CompanyName}. Access premium content, gifts, and private platforms. Indulge in the experience that awaits.`}
        keywords={KeywordsPages}
        additionalMeta={linksPageAdditionalMeta}
        structuredData={linksPageStructuredData}
      />

      <div className='grid relative min-h-screen font-poppins bg-colour2 text-colour1 dark:text-colour1'>
        {/* Main */}
        <div className='grid min-h-screen'>
          <Navbar />

          {/* Header styled like SessionsPage */}
          <header className='grid py-10 px-6 text-center gap-4 place-items-center'>
            <h1 className='neon_text_heavy_redpink font-titleFont text-4xl md:text-6xl tracking-wider drop-shadow-lg'>
              TRIBUTE & GIFTS
            </h1>
            <p className='max-w-2xl text-base md:text-lg leading-relaxed'>
              Show your devotion through{' '}
              <strong>tributes, gifts, and fan platforms</strong>. Lady Cinder —{' '}
              <em>circus freak fire-eater</em> and <em>neon-gothic goddess</em>{' '}
              — offers exclusive portals where your worship becomes tangible.
              Every tribute fuels the ritual, every gift a spark in the fire.
            </p>
          </header>

          {/* Page content */}
          <LinksPageMainContainer />

          <div className='pt-12'>
            <FooterComponent />
          </div>
        </div>
      </div>
    </>
  );
}

export default LinksPage;
